
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { CiamService } from 'src/app/services/CIAM/ciam.service';
import { filter, take } from 'rxjs';
import { ApiService } from 'src/app/services/apiService/api.service';
import { loginAuth0Model } from 'src/app/modules/login/models/loginModel';
import { LocalSessionStorage } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { LoginService } from 'src/app/services/dataLayer/login.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { jwtDecode } from 'jwt-decode';
import { ThankyouService } from '../../common/thankyou.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { HeaderStateService } from 'src/app/services/commonService/header-state.service';
import { environment } from 'src/environments/environment';
import { datadogRum } from '@datadog/browser-rum';
import { SafeRedirectService } from '../../common/safe-redirect.service';
import { WaitingComponent } from '../waiting/waiting.component';
import { CommonService } from '../../common/common.service';
import { parsePhoneNumberFromString } from 'libphonenumber-js';



@Component({
  selector: 'app-validate-login',
  imports: [WaitingComponent],
  templateUrl: './validate-login.component.html'
})
export class ValidateLoginComponent implements OnInit {
  userService: any;
  useremail: string = '';
  accesstoken: string = '';
  phoneVerify: boolean = true;
  countryCode: string = "";
  phoneNumber: string = "";
  ciamID: string = '';
  crmid: string = '';
  LocalSessionStorage = LocalSessionStorage;
  commonObj: any = {
    new: false,
    loginMessage: "",
    loginStatusCode: "",
    submitting: false
  }
  returnUrl: string = '/Dashboard';
  private firedEvents = new Set<string>();

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    public _ciamService: CiamService,
    private readonly _Apiservice: ApiService,
    private readonly _LoginDatalayer: LoginService,
    private readonly crypto: CryptoService,
    private readonly ThankyouService: ThankyouService,
    private readonly _camService: CamService,
    private readonly _headerState: HeaderStateService,
    private readonly route: ActivatedRoute,
    private readonly safeRedirect: SafeRedirectService,
    private readonly _CommonService: CommonService
  ) { }



  ngOnInit(): void {
    const rawReturnUrl =
      this.route.snapshot.queryParamMap.get('returnUrl') ||
      localStorage.getItem('returnUrl');
    this.returnUrl = this.safeRedirect.getSafeReturnUrl(rawReturnUrl);
    localStorage.removeItem('returnUrl');
    this.route.queryParams.subscribe(params => {
      const error = params['error'];
      const errorDescription = params['error_description'];

      if (error) {
        console.log('CIAM Error:', error, errorDescription);

        this.handleCiamError(error, errorDescription)
        return;
      }

      const isValidationLinkResponse =
        params['success'] !== undefined ||
        params['supportSignUp'] !== undefined ||
        params['supportForgotPassword'] !== undefined;

      if (isValidationLinkResponse) {
        this.handleValidationLinkResponse(params);
        return;
      }


      this.auth.isAuthenticated$
        .pipe(
          filter(isAuth => isAuth === true),
          take(1)
        )
        .subscribe(() => {
          this.fetchUserData();
        });

    });

  }
  fetchUserData() {
    const CLAIMS = {
      PHONE_VERIFIED: 'http://www.saudia.com/phone_verified',
      PHONE_NUMBER: 'http://www.saudia.com/phonenumber',
      CRM_ID: 'http://www.saudia.com/CRMID'
    };
    this.auth.idTokenClaims$
      .pipe(
        filter(claims => !!claims),
        take(1)
      )
      .subscribe(claims => {
        const phoneVerifyPopupShow = environment.ciamPhoneVerification;
        this.useremail = claims?.email ?? '';
        if (phoneVerifyPopupShow) {
          this.phoneVerify = claims?.[CLAIMS.PHONE_VERIFIED] ?? '';
        }
        if (!phoneVerifyPopupShow) {
          this.phoneVerify = true;
        }
        const phoneRaw = claims?.[CLAIMS.PHONE_NUMBER] ?? '';
        const parsed = this.parsePhoneNumber(phoneRaw);
        const crmid = claims?.[CLAIMS.CRM_ID];
        this.crmid = crmid;
        this.countryCode = parsed.countryCode;
        this.phoneNumber = parsed.phoneNumber;
        // use claims here
        this.handleAuthFlow();
      });
  }
  handleAuthFlow() {
    this.auth.getAccessTokenSilently()
      .pipe(take(1))
      .subscribe(token => {
        this.accesstoken = token;
        localStorage.setItem('CiamToken', this.accesstoken);
        const decoded: any = jwtDecode(this.accesstoken);
        localStorage.setItem('CIAMID', decoded.sub);
        localStorage.setItem('CRMID',  this.crmid);
        localStorage.setItem('email',  this.useremail);
        this.ciamID = decoded.sub;
        const isPhoneEmpty =
          !this.phoneNumber ||
          this.phoneNumber.trim() === '';

        if (this.phoneVerify === true) {
          this.login();
          return;
        }

        let heading = '';
        let description = '';
        let buttonText = '';
        if (isPhoneEmpty) {
          heading = 'Update your mobile number';
          description =
            'Please update your mobile number to ensure secure access to your account';
          buttonText = 'Update number';
        }
        else {
          heading = 'Verify your mobile number';
          description =
            'Please verify your mobile number to ensure secure access to your account';
          buttonText = 'Verify number';

        }

        // open Thankyou page
        this.ThankyouService.show({
          heading,
          description,
          buttonText,
          isShowButton: true,
          redirectUrl: '/',
          countryCode: this.countryCode,
          mobile: this.phoneNumber,
          ciamToken: this.accesstoken,
          email:this.useremail,
        });
      });

  }

  handleCiamError(error: string, description: string | null) {
    let heading = 'Login Failed';
    let message = 'Something went wrong. Please try again.';
    if (error === 'access_denied') {
      if (description?.includes('Organization')) {
        message = description;
      }
    }

    // ✅ Show same template like status = 8
    this.ThankyouService.show({
      heading: heading,
      description: message,
      buttonText: 'Go to HomePage',
      redirectUrl: '/'
    });
  }

  handleValidationLinkResponse(params: any) {
    let heading = 'Login Failed';
    //const success = params['success'] === 'true';

    // const heading = params['title'] ? decodeURIComponent(params['title']) : success ? 'Success' : 'Authentication Error';

    const description = params['message'] ? decodeURIComponent(params['message']) : '';

    this.ThankyouService.show({
      heading,
      description,
      buttonText: 'Go to HomePage',
      isShowButton: true,
      redirectUrl: '/'
    });
  }
  parsePhoneNumber(fullNumber: string) {
    if (!fullNumber) return { countryCode: '', phoneNumber: '' };

    try {
      const parsed = parsePhoneNumberFromString(fullNumber);
      if (parsed && parsed.countryCallingCode) {
        return {
          countryCode: `+${parsed.countryCallingCode}`,
          phoneNumber: parsed.nationalNumber as string
        };
      }
    } catch (e) {
      console.error('Error parsing phone number:', e);
    }

    return { countryCode: '', phoneNumber: fullNumber };
  }

  login() {
    const loginData: loginAuth0Model = {
      companyId: 'SAA',
      userName: this.useremail,
      CRMID: this.crmid,
      CIAMID: this.ciamID
    };
    this._Apiservice.loginAuth0(loginData).then(($res: any) => {
      localStorage.setItem('designation', $res?.data?.designation);
      localStorage.setItem('companyCurrency', $res?.data?.comp_cur);
      this.commonObj.submitting = false;
      sessionStorage.setItem(this.LocalSessionStorage.QL_ACCESS_TOKEN, $res.data.accessToken);
      localStorage.setItem(this.LocalSessionStorage.QL_ACCESS_TOKEN, $res.data.accessToken);
      sessionStorage.setItem(this.LocalSessionStorage.IS_INTERNATIONAL, $res.data.isInternational);
      sessionStorage.setItem(this.LocalSessionStorage.LOGIN_DETAILS, $res.data.encrpytdata);
      localStorage.setItem(this.LocalSessionStorage.LOGIN_DETAILS, $res.data.encrpytdata);
      localStorage.setItem(this.LocalSessionStorage.COMPANY_ID, "SAA");
      localStorage.setItem(this.LocalSessionStorage.LOGIN_ID, this.crypto.getValueFromKey("COMPID") as string);
      localStorage.setItem(this.LocalSessionStorage.SUBAGENT_ID, $res.data.subAgentId);
      localStorage.setItem(this.LocalSessionStorage.USER_GUID, $res.data.userGuid);
      localStorage.setItem(this.LocalSessionStorage.ADDITIONAL_REF_NO, this.crypto.getValueFromKey("ADDITIONALREFNO") as string);

      let expiresInSec = 8 * 60;

      // Extract expires_in from Auth0 cache
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('@@auth0spajs@@::')) {
          try {
            const cacheItem = JSON.parse(localStorage.getItem(key) || '{}');
            if (cacheItem && cacheItem.body && cacheItem.body.expires_in) {
              expiresInSec = cacheItem.body.expires_in;
              break;
            }
          } catch (e) {
            // Ignore
          }
        }
      }

      // Fallback 1: Decode the JWT directly if cache was somehow missed
      if (expiresInSec === 8 * 60 && this.accesstoken) {
        try {
          const decodedToken: any = jwtDecode(this.accesstoken);
          if (decodedToken && decodedToken.exp) {
            const iat = decodedToken.iat || Math.floor(Date.now() / 1000);
            expiresInSec = decodedToken.exp - iat;
          }
        } catch (e) {
          // Ignore
        }
      }

      // Fallback 2: Backend API response
      if (expiresInSec === 8 * 60 && ($res?.data?.expires_in || $res?.data?.expiresIn)) {
        expiresInSec = $res?.data?.expires_in || $res?.data?.expiresIn;
      }

      const auth0RefreshInMs = expiresInSec * 1000;
      localStorage.setItem('auth0_expires_in_ms', auth0RefreshInMs.toString());
      localStorage.setItem('auth0_token_expiry_time', (new Date().getTime() + auth0RefreshInMs).toString());
      const corpLogo = $res?.data?.logoUrl;

      this._headerState.setCompanyLogo(
        corpLogo?.includes('blob:')
          ? corpLogo
          : ['DELETE', 'CHANGE', 'NOCHANGE'].includes(corpLogo)
            ? ''
            : this.getUpdatedLogoUrl(corpLogo)
      );

      localStorage.setItem('login_provider', 'auth0');

      datadogRum.setUser({
        id: this.ciamID ?? '',
        name: `${this.crypto.getValueFromKey('USERFNAME') ?? ''} ${this.crypto.getValueFromKey('USERLNAME') ?? ''}`.trim() || undefined,
        company: this.crypto.getValueFromKey('COMPANYNAME') ?? undefined,
      });

      this.router.navigateByUrl(this.returnUrl);
      this._camService.getCompanySetting().then((companyRes: any) => {
        if (companyRes?.status === 'Success' && companyRes?.data) {
          const companySettingsJson = JSON.stringify(companyRes?.data);
          localStorage.setItem(this.LocalSessionStorage.COMPANY_SETTINGS, companySettingsJson);
          sessionStorage.setItem(this.LocalSessionStorage.COMPANY_SETTINGS, companySettingsJson);
        }
      }).catch(() => {
        // Non-blocking: navigate even if company settings fail
      }).finally(() => {
        this._CommonService.loadPostLoginContent();
        this.router.navigateByUrl(this.returnUrl);
        // this._LoginDatalayer.corporate_login_success(); // GTM use
      });

    //Call here login script 

      this.fireOnce('b2bLoginSuccess', () => {
        const rawValue = $res.data?.alFursanId ?? '';
        const alFursanId = /^\d+$/.test(rawValue) ? Number(rawValue) : rawValue;
        sessionStorage.setItem('alFursanId', rawValue);
        this._LoginDatalayer.b2b_loginsuccess(alFursanId,$res?.data?.accountId);
      });

    }).catch(($err: { error: { message: string; data: any }; status: number; }) => {
      this.commonObj.loginMessage = $err.error.message;
      this.commonObj.submitting = false;

      const errorCode = $err?.error?.data;
      const errorMessage = $err?.error?.message;

      if (errorCode === 8) {
        this.ThankyouService.show({
          heading: errorMessage,
          description: errorMessage,
          buttonText: 'Go to HomePage',
          isShowButton: true,
          redirectUrl: '/'
        });
        return;
      }

      // this._LoginDatalayer.corporate_login_failure($err.error.message, $err.error.status)   //GTM use

      //If branch not assigned to user or assign branch is deactivated.
      if ($err?.error?.message === '@queryNo 2' || $err?.status === 500) {
        this.commonObj.loginMessage = 'Invalid Credentials';
        this.commonObj.loginStatusCode = 'Failure';
        this.commonObj.submitting = false;
      }
    })
  }

  private fireOnce(key: string, callback: () => void): void {
    if (this.firedEvents.has(key)) {
      return;
    }

    this.firedEvents.add(key);
    callback();
  }

  getUpdatedLogoUrl(corpLogo: string): string {
    if (!corpLogo) return '';

    if (['DELETE', 'CHANGE', 'NOCHANGE'].includes(corpLogo)) {
      return '';
    }

    if (!corpLogo.includes('http')) return corpLogo;

    const currentUrl = window.location.href;
    const baseUrl = currentUrl.split('/business/')[0] + '/business/';

    const index = corpLogo.indexOf('images');
    if (index === -1) return corpLogo;

    const logoPath = corpLogo.substring(index);
    const updatedLogoUrl = baseUrl + logoPath;
    return updatedLogoUrl;
  }
}
